import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'pfoffers';
export const route = 'pfoffers/[searchId]/[fareItineraryKey]/[segmentKeys]/[shoppingId]/';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import(/* webpackChunkName: "pfoffers" */
/* webpackPrefetch: true */
'../components/OffersPage')));